import { render } from "./DropDownListPatFormaTombamento.vue?vue&type=template&id=9e7cabcc&ts=true"
import script from "./DropDownListPatFormaTombamento.vue?vue&type=script&lang=ts"
export * from "./DropDownListPatFormaTombamento.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__